// tslint:disable-next-line:typedef
export function CanvasComponent(target) {
  target.isCanvasComponent = true;
}
